import { render, staticRenderFns } from "./apnIndex.vue?vue&type=template&id=67f4a44e&scoped=true"
import script from "./apnIndex.vue?vue&type=script&lang=js"
export * from "./apnIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f4a44e",
  null
  
)

export default component.exports